// extracted by mini-css-extract-plugin
export var cell = "_5z-4";
export var headerCell = "_5z-2";
export var rowHeader = "_5z-3";
export var table = "_5z-1";
export var tableContainer = "_5z-0";